import { render, staticRenderFns } from "./FiltersForSuperBoard.vue?vue&type=template&id=5ad05916&"
import script from "./FiltersForSuperBoard.vue?vue&type=script&lang=js&"
export * from "./FiltersForSuperBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad05916')) {
      api.createRecord('5ad05916', component.options)
    } else {
      api.reload('5ad05916', component.options)
    }
    module.hot.accept("./FiltersForSuperBoard.vue?vue&type=template&id=5ad05916&", function () {
      api.rerender('5ad05916', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/kanban/components/FiltersForSuperBoard.vue"
export default component.exports